(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-top-bar"] && !Shopify.designMode) return;
  try {
    
  const ROTATE_INTERVAL = 2000;
  const MOBILE_BREAKPOINT = 1050;

  const initUspRotation = () => {
    const usps = document.querySelectorAll('.custom-top-bar__usp');
    if (usps.length < 2) return;

    let current = 0;
    let interval = null;

    const rotate = () => {
      usps[current].classList.remove('custom-top-bar__usp--active');
      usps[current].setAttribute('aria-hidden', 'true');

      current = (current + 1) % usps.length;

      usps[current].classList.add('custom-top-bar__usp--active');
      usps[current].removeAttribute('aria-hidden');
    };

    const start = () => {
      if (interval) return;
      interval = setInterval(rotate, ROTATE_INTERVAL);
    };

    const stop = () => {
      clearInterval(interval);
      interval = null;
    };

    const handleResize = () => {
      if (window.innerWidth < MOBILE_BREAKPOINT) {
        start();
      } else {
        stop();
        for (const usp of usps) {
          usp.classList.add('custom-top-bar__usp--active');
          usp.removeAttribute('aria-hidden');
        }
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUspRotation);
  } else {
    initUspRotation();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
